import { render, staticRenderFns } from "./EditRoleNameModal.vue?vue&type=template&id=7606ee5f"
import script from "./EditRoleNameModal.vue?vue&type=script&lang=js"
export * from "./EditRoleNameModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports